































import moment from 'moment';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
class timeRangePick extends Vue {
  @Prop()
  meetingDate;

  @Prop()
  meetingTimeRange;

  data: any[] = [];
  moment: any = moment;
  date: any = null;
  dateTmp: any = null;
  time1: any = {};
  time2: any = undefined;
  time1Tmp: any = {};
  time2Tmp: any = undefined;
  dateChangeFlag: boolean = true;
  startTime: any = null;
  endTime: any = null;
  timeOpen: boolean = false;
  timeOpenTmp: boolean = true;

  @Watch('meetingTimeRange', { immediate: true })
  timeRangeChange(val) {
    if (val[0] && val[1]) {
      this.date = moment.unix(val[0]);
      this.time1 = moment.unix(val[0]);
      this.time2 = moment.unix(val[1]);
      this.time1Tmp = this.time1;
      this.time2Tmp = this.time2;
      this.dateTmp = this.date;
    } else if (val[0] && val[1] === 0) {
      this.date = moment.unix(val[0]);
      this.time1 = moment.unix(val[0]);
      this.time2 = undefined;
      this.time1Tmp = this.time1;
      this.time2Tmp = undefined;
      this.dateTmp = this.date;
    }
  }

  mounted() {}

  getDisabledHoursStart() {
    // console.log(val);
    // return true;
    let res: any = [];
    if (this.time2 instanceof moment) {
      //@ts-ignore
      let now = this.time2.hour();
      for (let i = now + 1; i < 24; i++) {
        res.push(i);
      }
    }
    return res;
  }

  getDisabledMinutesStart() {
    let res: any = [];
    if (this.time2 instanceof moment) {
      //@ts-ignore
      if (this.time1.hour() === this.time2.hour()) {
        //@ts-ignore
        let now = this.time2.minute();
        for (let i = now; i < 60; i++) {
          res.push(i);
        }
      }
    }
    return res;
  }

  getDisabledHoursEnd() {
    let res: any = [];
    if (this.time1 instanceof moment) {
      //@ts-ignore
      let now = this.time1.hour();
      for (let i = 0; i < now; i++) {
        res.push(i);
      }
    }
    return res;
  }

  getDisabledMinutesEnd() {
    let res: any = [];
    if (this.time1 instanceof moment) {
      // time2可能为0
      //@ts-ignore
      if (this.time2 && this.time1.hour() === this.time2.hour()) {
        //@ts-ignore
        let now = this.time1.minute();
        for (let i = 0; i <= now; i++) {
          res.push(i);
        }
      }
    }
    return res;
  }

  // time1变化
  resultChange1(e) {
    // 空白输入时,重置为上一次选择的结果
    if (!e) {
      this.time1 = this.time1Tmp;
    }

    this.startTime = this.date.clone().startOf('day');
    this.startTime.add(this.time1.hour(), 'h').add(this.time1.minute(), 'm');

    this.time1Tmp = this.time1;
    this.dateTmp = this.date;
  }

  // time2变化
  resultChange2(e) {
    // 空白输入时,重置为上一次选择的结果
    if (!this.time2Tmp || !e) {
      if (!e) {
        this.time2 = this.time2Tmp;
      }

      this.endTime = this.date.clone().startOf('day');
      this.endTime.add(this.time2.hour(), 'h').add(this.time2.minute(), 'm');

      this.time2Tmp = this.time2;
    }
  }

  dateChange(e) {
    // 空白输入时,重置为上一次选择的结果
    if (!e) {
      this.date = this.dateTmp;
    } else {
      this.dateTmp = this.date;
    }
    this.emitDate();
  }

  openChange(open) {
    if (!open) {
      this.emitDate();
    }
  }

  emitDate() {
    // this.timeOpen = false;
    this.startTime = this.date.clone().startOf('day');
    this.startTime.add(this.time1.hour(), 'h').add(this.time1.minute(), 'm');
    if (this.time2) {
      this.endTime = this.date.clone().startOf('day');
      this.endTime.add(this.time2.hour(), 'h').add(this.time2.minute(), 'm');
      this.$emit('meetingTimeChange', [this.startTime.unix(), this.endTime.unix()]);
    } else {
      this.$emit('meetingTimeChange', [this.startTime.unix(), 0]);
    }
  }
}
export default timeRangePick;
